import { Aletheia, type AletheiaConfig } from './Aletheia'
import { GA4, type GA4Config } from './GA4'
import { Klaviyo, type KlaviyoConfig } from './Klaviyo'
import { MetaPixel, type MetaPixelConfig } from './MetaPixel'
import { Omnichat, type OmniChatConfig } from './Omnichat'
import { OmniSegmentCdp, type OmniSegmentCdpConfig } from './OmniSegmentCdp'
import { Statsig, type StatsigConfig } from './Statsig'
import { TikTokPixel, type TikTokPixelConfig } from './TikTokPixel'

export enum AnalyticsPlatforms {
  GA4 = 'GA4',
  KLAVIYO = 'KLAVIYO',
  META_PIXEL = 'META_PIXEL',
  TIK_TOK_PIXEL = 'TIK_TOK_PIXEL',
  OMNI_SEGMENT_CDP = 'OMNI_SEGMENT_CDP',
  ALETHEIA = 'ALETHEIA',
  OMNICHAT = 'OMNICHAT',
  STATSIG = 'STATSIG',
}

export type AnalyticsConfig = Partial<{
  [AnalyticsPlatforms.GA4]: GA4Config
  [AnalyticsPlatforms.KLAVIYO]: KlaviyoConfig
  [AnalyticsPlatforms.META_PIXEL]: MetaPixelConfig
  [AnalyticsPlatforms.TIK_TOK_PIXEL]: TikTokPixelConfig
  [AnalyticsPlatforms.OMNI_SEGMENT_CDP]: OmniSegmentCdpConfig
  [AnalyticsPlatforms.ALETHEIA]: AletheiaConfig
  [AnalyticsPlatforms.OMNICHAT]: OmniChatConfig
  [AnalyticsPlatforms.STATSIG]: StatsigConfig
}>

const analyticsInstances: Partial<{
  [AnalyticsPlatforms.GA4]: GA4
  [AnalyticsPlatforms.KLAVIYO]: Klaviyo
  [AnalyticsPlatforms.META_PIXEL]: MetaPixel
  [AnalyticsPlatforms.TIK_TOK_PIXEL]: TikTokPixel
  [AnalyticsPlatforms.OMNI_SEGMENT_CDP]: OmniSegmentCdp
  [AnalyticsPlatforms.ALETHEIA]: Aletheia
  [AnalyticsPlatforms.OMNICHAT]: Omnichat
  [AnalyticsPlatforms.STATSIG]: Statsig
}> = {}

export const getAnalyticsPlatforms = () => Object.keys(analyticsInstances) as AnalyticsPlatforms[]

export const createAnalyticsProviders = (config: AnalyticsConfig) => {
  Object.keys(config).forEach((platform) => {
    if (platform === AnalyticsPlatforms.GA4 && config[AnalyticsPlatforms.GA4]) {
      analyticsInstances[AnalyticsPlatforms.GA4] = GA4.getInstance(config[AnalyticsPlatforms.GA4])
    }
    if (platform === AnalyticsPlatforms.KLAVIYO && config[AnalyticsPlatforms.KLAVIYO]) {
      analyticsInstances[AnalyticsPlatforms.KLAVIYO] = Klaviyo.getInstance(config[AnalyticsPlatforms.KLAVIYO])
    }
    if (platform === AnalyticsPlatforms.META_PIXEL && config[AnalyticsPlatforms.META_PIXEL]) {
      analyticsInstances[AnalyticsPlatforms.META_PIXEL] = MetaPixel.getInstance(config[AnalyticsPlatforms.META_PIXEL])
    }
    if (platform === AnalyticsPlatforms.TIK_TOK_PIXEL && config[AnalyticsPlatforms.TIK_TOK_PIXEL]) {
      analyticsInstances[AnalyticsPlatforms.TIK_TOK_PIXEL] = TikTokPixel.getInstance(config[AnalyticsPlatforms.TIK_TOK_PIXEL])
    }
    if (platform === AnalyticsPlatforms.OMNI_SEGMENT_CDP && config[AnalyticsPlatforms.OMNI_SEGMENT_CDP]) {
      analyticsInstances[AnalyticsPlatforms.OMNI_SEGMENT_CDP] = OmniSegmentCdp.getInstance(config[AnalyticsPlatforms.OMNI_SEGMENT_CDP])
    }
    if (platform === AnalyticsPlatforms.ALETHEIA && config[AnalyticsPlatforms.ALETHEIA]) {
      analyticsInstances[AnalyticsPlatforms.ALETHEIA] = Aletheia.getInstance(config[AnalyticsPlatforms.ALETHEIA])
    }
    if (platform === AnalyticsPlatforms.OMNICHAT && config[AnalyticsPlatforms.OMNICHAT]) {
      analyticsInstances[AnalyticsPlatforms.OMNICHAT] = Omnichat.getInstance(config[AnalyticsPlatforms.OMNICHAT])
    }
    if (platform === AnalyticsPlatforms.STATSIG && config[AnalyticsPlatforms.STATSIG]) {
      analyticsInstances[AnalyticsPlatforms.STATSIG] = Statsig.getInstance(config[AnalyticsPlatforms.STATSIG])
    }
  })
}

export const getAnalyticsInstance = <P extends AnalyticsPlatforms>(platform: P) => analyticsInstances[platform]
